import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { TableHelper } from '../../../../tables'
import { QuestionTable } from '../../../../tables/question-table'

const Questions = observer(() => {
  const match = useRouteMatch<any>('/content/quizzes/:id/questions')
  const quizID = Number(match?.params?.id)

  const [tableHelper] = useState(
    new TableHelper('list_quiz_questions', 'questions', 'quizzes', quizID),
  )

  return <QuestionTable tableHelper={tableHelper} />
})

export const QuizzesQuestionsTab = (props: any) => {
  const { id } = props
  return {
    name: 'Questions',
    path: `/content/quizzes/${id}/questions`,
    component: () => <Questions />,
  }
}
